import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const distributeAsset = (data) => request.post(`${API_BASE_URL}/blockchain/distribute`, data)

export default distributeAsset